'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FAIcon = require('./../icon/FAIcon');

var _FAIcon2 = _interopRequireDefault(_FAIcon);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _i18n = require('./../i18n/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _ModalActions = require('./ModalActions');

var ModalActions = _interopRequireWildcard(_ModalActions);

var _reactstrap = require('reactstrap');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Abstraktní předek pro modální dialogy.
 */

var AbstractModal = function (_AbstractReactCompone) {
    (0, _inherits3.default)(AbstractModal, _AbstractReactCompone);

    function AbstractModal() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AbstractModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AbstractModal.__proto__ || (0, _getPrototypeOf2.default)(AbstractModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleDialogClose = function () {
            var submitting = _this.props.submitting;


            !submitting && _this.props.dispatch(ModalActions.hide());
        }, _this.content = function () {
            return _react2.default.createElement(
                'div',
                null,
                _this.body(),
                _this.footer()
            );
        }, _this.body = function () {
            return _react2.default.createElement(
                _reactstrap.Modal.Body,
                null,
                '...dialog body...'
            );
        }, _this.header = function (title) {
            return _react2.default.createElement(
                _reactstrap.Modal.Header,
                null,
                _react2.default.createElement(
                    _reactstrap.Modal.Title,
                    null,
                    title
                )
            );
        }, _this.footer = function () {
            var saveTitle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _i18n2.default)('accept');
            var _this$props = _this.props,
                pristine = _this$props.pristine,
                submitting = _this$props.submitting;

            return _react2.default.createElement(
                _reactstrap.Modal.Footer,
                null,
                _react2.default.createElement(
                    _reactstrap.Button,
                    { color: 'success', type: 'submit', disabled: pristine || submitting },
                    _react2.default.createElement(_FAIcon2.default, { icon: 'check' }),
                    ' ',
                    saveTitle
                ),
                _react2.default.createElement(
                    _reactstrap.Button,
                    { color: 'danger', disabled: submitting, onClick: _this.handleDialogClose },
                    _react2.default.createElement(_FAIcon2.default, { icon: 'times' }),
                    ' Close'
                )
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AbstractModal, [{
        key: 'render',
        value: function render() {
            var dialogTitle = this.props.dialogTitle;


            return _react2.default.createElement(
                'div',
                null,
                this.header(dialogTitle),
                this.content()
            );
        }
    }]);
    return AbstractModal;
}(_AbstractReactComponent2.default);

exports.default = AbstractModal;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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